import React from 'react';

import type { FacebookGroupPostComponentsProps } from './types';

export function Header(_props: FacebookGroupPostComponentsProps): React.JSX.Element {
	return <div>Facebook Group Post Header</div>;
}
